import { ActionReducerMap } from '@ngrx/store';
import { additionalServicesReducer, AdditionalServicesState } from '../additional-services/additional-services.reducer';
import { applicationModulesReducer, ApplicationModulesState } from '../application-modules/application-modules.reducer';
import { ArkikProductsState } from '../arkik-products/arkik-products.models';
import { arkikProductsReducer } from '../arkik-products/arkik-products.reducer';
import { automaticChargesReducer, AutomaticChargesState } from '../automatic-charges/automatic-charges.reducer';
import { BusinessPlantDetailState } from '../business-plant-detail/business-plant-detail.models';
import { businessPlantDetailReducer } from '../business-plant-detail/business-plant-detail.reducer';
import { calculateRoutesReducer, CalculateRoutesState } from '../calculate-routes/calculate-routes.reducer';
import { calendarsPartnerReducer, CalendarsPartnerState } from '../calendars-partner/calendars-partner.reducer';
import { cashPaymentTypesReducer, CashPaymentTypesState } from '../cash-payment-types/cash-payment-types.reducer';
import { CatalogsVehicleState } from '../catalog-vehicle/catalog-vehicle.models';
import { catalogsVehicleReducer } from '../catalog-vehicle/catalog-vehicle.reducer';
import { CatalogsState } from '../catalogs/catalogs.models';
import { catalogsReducer } from '../catalogs/catalogs.reducer';
import { CompanyInfoState } from '../company-info/company-info.models';
import { companyInfoReducer } from '../company-info/company-info.reducer';
import {
  contractsByJobsiteReducer,
  ContractsByJobsiteState,
} from '../contracts-by-jobsite/contracts-by-jobsite.reducer';
import { deliveryScheduleReducer, DeliveryScheduleState } from '../delivery-schedule/delivery-schedule.reducer';
import {
  driverManagementDriversReducer,
  DriverManagementDriversState,
} from '../driver-management-drivers/driver-management-drivers.reducer';
import { GroupCatalogsState } from '../group-catalogs/group-catalogs.models';
import { groupCatalogsReducer } from '../group-catalogs/group-catalogs.reducer';
import { inventoryByPlantReducer, InventoryByPlantState } from '../inventory-by-plant/inventory-by-plant.reducer';
import { LoginState } from '../login/login.models';
import { loginReducer } from '../login/login.reducer';
import {
  measurementItemsMxReducer,
  MeasurementItemsMxState,
} from '../measurement-items-mx/measurement-items-mx.reducer';
import { MenuByUserState } from '../menu-by-user/menu-by-user.model';
import { menuByUserReducer } from '../menu-by-user/menu-by-user.reducer';
import { newOrderSelectReducer, NewOrderSelectState } from '../new-order-select/new-order-select.reducer';
import { orderCodeReducer, OrderCodeState } from '../order-code/order-code.reducer';
import { orderDefaultDataReducer, OrderDefaultDataState } from '../order-default-data/order-default-data.reducer';
import { orderItemTypesReducer, OrderItemTypesState } from '../order-item-types/order-item-types.reducer';
import { orderTypesReducer, OrderTypesState } from '../order-types/order-types.reducer';
import { orderValidationReducer, OrderValidationState } from '../order-validation/order-validation.reducer';
import { parameterDetailReducer, ParametersState } from '../parameter-by-detail/parameter-by-detail.reducer';
import { parametersDataReducer, ParametersDataState } from '../parameters-data/parameters-data.reducer';
import { partnerPlantsReducer, PartnerPlantsState } from '../partner-plants/partner-plants.reducer';
import { partnersCatalogReducer, PartnersCatalogState } from '../partners-catalog/partners-catalog.reducer';
import { paymentTermsReducer, PaymentTermsState } from '../payment-terms/payment-terms.reducer';
import { PlantListCompanyByUserGuidState } from '../plant-list-company-by-userguid/plant-list-company-by-userguid.models';
import { plantListCompanyByUserGuidReducer } from '../plant-list-company-by-userguid/plant-list-company-by-userguid.reducer';
import { PlantListCompanyState } from '../plant-list-company/plant-list-company.models';
import { plantListCompanyReducer } from '../plant-list-company/plant-list-company.reducer';
import { PlantListUserGuidState } from '../plant-list-userguid/plant-list-userguid.models';
import { plantListUserGuidReducer } from '../plant-list-userguid/plant-list-userguid.reducer';
import { PlantsNetworkState } from '../plant-network-status/plant-network-status.models';
import { plantNetworkStatusReducer } from '../plant-network-status/plant-network-status.reducer';
import { FeatureAvailabilityState } from '../feature-availability/feature-availability.models';
import { featureAvailabilityReducer } from '../feature-availability/feature-availability.reducer';
import { plantsBySubgroupReducer, PlantsBySubgroupState } from '../plants-by-subgroup/plants-by-subgroup.reducer';
import {
  plantsWithBOMByProductListReducer,
  PlantsWithBOMByProductListState,
} from '../plants-with-bom-by-product-list/plants-with-bom-by-product-list.reducer';
import { productPriceReducer, ProductPriceState } from '../product-price/product-price.reducer';
import { salesChannelsReducer, SalesChannelsState } from '../sales-channels/sales-channels.reducer';
import { taxClassReducer, TaxClassState } from '../tax-class/tax-class.reducer';
import {
  taxJurisdictionRateReducer,
  TaxJurisdictionRateState,
} from '../tax-jurisdiction-rate/tax-jurisdiction-rate.reducer';
import { taxJurisdictionsReducer, TaxJurisdictionsState } from '../tax-jurisdictions/tax-jurisdictions.reducer';
import { userPermissionsReducer, UserPermissionsState } from '../user-permissions/user-permissions.reducer';
import { UserRolesState } from '../user-roles/user-roles.models';
import { userRolesReducer } from '../user-roles/user-roles.reducer';
import { variableDosageReducer, VariableDosageState } from '../variable-dosage/variable-dosage.reducer';
import { actionBarPortalFeatureKey, ActionBarPortalState, actionBarPortalReducer } from 'core';

export interface AppState {
  actionBarPortal?: ActionBarPortalState;
  additionalServices: AdditionalServicesState;
  applicationModules?: ApplicationModulesState;
  arkikProducts?: ArkikProductsState;
  businessPlantDetail?: BusinessPlantDetailState;
  catalogs?: CatalogsState;
  catalogsVehicle?: CatalogsVehicleState;
  companyInfo?: CompanyInfoState;
  groupCatalogs?: GroupCatalogsState;
  login?: LoginState;
  menuByUser?: MenuByUserState;
  orderCode?: OrderCodeState;
  parametersDetail: ParametersState;
  plantListCompany?: PlantListCompanyState;
  plantListCompanyByUserGuid?: PlantListCompanyByUserGuidState;
  plantListUserGuid?: PlantListUserGuidState;
  userRoles?: UserRolesState;
  plantNetworkStatus?: PlantsNetworkState;
  featureAvailability?: FeatureAvailabilityState;
  newOrderSelect?: NewOrderSelectState;
  variableDosage?: VariableDosageState;
  inventoryByPlant?: InventoryByPlantState;
  orderValidation?: OrderValidationState;
  userPermissions?: UserPermissionsState;
  measurementItemsMx?: MeasurementItemsMxState;
  parametersData?: ParametersDataState;
  partnerPlants?: PartnerPlantsState;
  automaticCharges?: AutomaticChargesState;
  orderTypes?: OrderTypesState;
  paymentTerms?: PaymentTermsState;
  salesChannels?: SalesChannelsState;
  taxJurisdictions?: TaxJurisdictionsState;
  taxJurisdictionRate?: TaxJurisdictionRateState;
  orderItemTypes?: OrderItemTypesState;
  plantsBySubgroup?: PlantsBySubgroupState;
  taxClass?: TaxClassState;
  cashPaymentTypes?: CashPaymentTypesState;
  orderDefaultData?: OrderDefaultDataState;
  contractsByJobsite?: ContractsByJobsiteState;
  deliverySchedule?: DeliveryScheduleState;
  driverManagementDrivers?: DriverManagementDriversState;
  plantsWithBOMByProductList?: PlantsWithBOMByProductListState;
  calendarsPartner?: CalendarsPartnerState;
  productPrice?: ProductPriceState;
  calculateRoutes?: CalculateRoutesState;
  partnersCatalog?: PartnersCatalogState;
}

export const reducers: ActionReducerMap<AppState> = {
  [actionBarPortalFeatureKey]: actionBarPortalReducer,
  additionalServices: additionalServicesReducer,
  applicationModules: applicationModulesReducer,
  arkikProducts: arkikProductsReducer,
  businessPlantDetail: businessPlantDetailReducer,
  catalogs: catalogsReducer,
  catalogsVehicle: catalogsVehicleReducer,
  companyInfo: companyInfoReducer,
  groupCatalogs: groupCatalogsReducer,
  login: loginReducer,
  menuByUser: menuByUserReducer,
  orderCode: orderCodeReducer,
  parametersDetail: parameterDetailReducer,
  plantListCompany: plantListCompanyReducer,
  plantListCompanyByUserGuid: plantListCompanyByUserGuidReducer,
  plantListUserGuid: plantListUserGuidReducer,
  userRoles: userRolesReducer,
  plantNetworkStatus: plantNetworkStatusReducer,
  featureAvailability: featureAvailabilityReducer,
  newOrderSelect: newOrderSelectReducer,
  variableDosage: variableDosageReducer,
  inventoryByPlant: inventoryByPlantReducer,
  orderValidation: orderValidationReducer,
  userPermissions: userPermissionsReducer,
  measurementItemsMx: measurementItemsMxReducer,
  parametersData: parametersDataReducer,
  partnerPlants: partnerPlantsReducer,
  automaticCharges: automaticChargesReducer,
  orderTypes: orderTypesReducer,
  paymentTerms: paymentTermsReducer,
  salesChannels: salesChannelsReducer,
  taxJurisdictions: taxJurisdictionsReducer,
  taxJurisdictionRate: taxJurisdictionRateReducer,
  orderItemTypes: orderItemTypesReducer,
  plantsBySubgroup: plantsBySubgroupReducer,
  taxClass: taxClassReducer,
  cashPaymentTypes: cashPaymentTypesReducer,
  orderDefaultData: orderDefaultDataReducer,
  contractsByJobsite: contractsByJobsiteReducer,
  deliverySchedule: deliveryScheduleReducer,
  driverManagementDrivers: driverManagementDriversReducer,
  plantsWithBOMByProductList: plantsWithBOMByProductListReducer,
  calendarsPartner: calendarsPartnerReducer,
  productPrice: productPriceReducer,
  calculateRoutes: calculateRoutesReducer,
  partnersCatalog: partnersCatalogReducer,
};
